module.exports = __webpack_public_path__ + "img/ans-logo.d84c7d0f.svg";